import React from "react";
import { RiErrorWarningFill } from "react-icons/ri";
const WarningModal = ({ show, remainingTime, onStayLoggedIn }) => {
  if (!show) return null;

  return (
    <div className="logout-warning-modal">
      <div className="logout-warning-modal-content">
        <div className="autologout-warning-icon">
          <RiErrorWarningFill />
        </div>
        <div>
          <p>
            You will be logged out in <span>{remainingTime}</span> seconds due
            to inactivity.
          </p>
        </div>
        <button onClick={onStayLoggedIn}>Stay Logged In</button>
      </div>
    </div>
  );
};

export default WarningModal;
